"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5793,5457,9078,1521,9213,2794,9347,6402],{

/***/ 15457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCheckmarkCircle = function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .333A6.667 6.667 0 1 0 13.668 7 6.674 6.674 0 0 0 7.001.333ZM7 13a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M9.765 5.097 6.237 8.626a.333.333 0 0 1-.472 0L4.237 7.097a.334.334 0 0 0-.472.472l1.528 1.528a1 1 0 0 0 1.415 0l3.529-3.528a.334.334 0 1 0-.472-.472Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCheckmarkCircle);

/***/ }),

/***/ 19078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDerecha = function SvgDerecha(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff",
      stroke: "CurrentColor",
      strokeWidth: 1
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M58.333 50 75 66.667 58.333 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M66.667 129.167c34.518 0 62.5-27.982 62.5-62.5s-27.982-62.5-62.5-62.5-62.5 27.982-62.5 62.5 27.982 62.5 62.5 62.5Zm0 4.166c36.819 0 66.666-29.847 66.666-66.666C133.333 29.848 103.486 0 66.667 0 29.848 0 0 29.848 0 66.667s29.848 66.666 66.667 66.666Z",
    style: {
      fill: "CurrentColor"
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgDerecha);

/***/ }),

/***/ 41521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDerechaSinBorde = function SvgDerechaSinBorde(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff",
      stroke: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M58.333 50 75 66.667 58.333 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgDerechaSinBorde);

/***/ }),

/***/ 59213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIzquierda = function SvgIzquierda(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M75 50 58.333 66.667 75 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M66.667 129.167c34.518 0 62.5-27.982 62.5-62.5s-27.982-62.5-62.5-62.5-62.5 27.982-62.5 62.5 27.982 62.5 62.5 62.5Zm0 4.166c36.819 0 66.666-29.847 66.666-66.666C133.333 29.848 103.486 0 66.667 0 29.848 0 0 29.848 0 66.667s29.848 66.666 66.667 66.666Z",
    style: {
      fill: "CurrentColor"
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgIzquierda);

/***/ }),

/***/ 62794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIzquierdaSinBorde = function SvgIzquierdaSinBorde(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 134 134"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: 66.581,
    cy: 66.653,
    rx: 64.01,
    ry: 64.438,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M75 50 58.333 66.667 75 83.333",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: "6.67px"
    }
  }));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgIzquierdaSinBorde);

/***/ }),

/***/ 53516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 .667A6.333 6.333 0 1 0 13.334 7 6.341 6.341 0 0 0 7 .667Zm0 12A5.666 5.666 0 1 1 12.667 7 5.673 5.673 0 0 1 7 12.667Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 3.667A.333.333 0 0 0 6.667 4v3.996a.333.333 0 1 0 .667 0V4A.333.333 0 0 0 7 3.667ZM7 9a.333.333 0 0 1 .334.333V10a.333.333 0 1 1-.667 0v-.667A.333.333 0 0 1 7 9Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgWarningCircle);

/***/ }),

/***/ 46402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Galeria_PopUpGaleria; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(43203);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(9434);
// EXTERNAL MODULE: ./components/atoms/pop-up-base/index.ts + 1 modules
var pop_up_base = __webpack_require__(53117);
// EXTERNAL MODULE: ./public/assets/icons/Derecha.svg
var Derecha = __webpack_require__(19078);
// EXTERNAL MODULE: ./public/assets/icons/Izquierda.svg
var Izquierda = __webpack_require__(59213);
;// CONCATENATED MODULE: ./components/atoms/multimedia/Galeria/PopUpGaleria/PopUpGaleria.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "PopUp relative cursor-pointer ",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









/**
 * PopUpGaleria
 */ var ThumbsElement = function(images, setThumbsSwiper, selectedIndex, setIndex) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onSwiper: setThumbsSwiper,
        className: "absolute h-[108px] w-[90vw] sm:w-[424px]",
        spaceBetween: 16,
        breakpoints: {
            0: {
                slidesPerView: 3
            },
            370: {
                slidesPerView: 4
            }
        },
        freeMode: true,
        watchSlidesProgress: true,
        modules: [
            modules/* FreeMode */.Rv,
            modules/* Navigation */.W_,
            modules/* Thumbs */.o3
        ],
        onActiveIndexChange: function(e) {
            return setIndex(e.activeIndex);
        },
        centerInsufficientSlides: true,
        children: images.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: (0,es/* oneLine */.f9)(_templateObject(), selectedIndex === index ? 'after:absolute after:bottom-0 after:left-[18px] after:right-[18px] after:block after:h-0.5 after:bg-secondary-400 after:content-[""]' : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[94px] w-[94px] border-2 ".concat(selectedIndex === index ? "border-white" : "border-transparent"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: item,
                        alt: "Imagen de la vivienda Thumbnail ".concat(index + 1),
                        width: 94,
                        height: 94,
                        objectFit: "cover",
                        className: "Imagen u-aspect-square"
                    })
                })
            }, index);
        })
    });
};
var PopUpGaleria = function(param) {
    var state = param.state, images = param.images, setState = param.setState, className = param.className, title = param.title, desc = param.desc, _initialIndex = param.initialIndex, initialIndex = _initialIndex === void 0 ? 0 : _initialIndex;
    var ref = (0,react.useState)(null), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    var ref1 = (0,react.useState)(initialIndex), selectedIndex = ref1[0], setSelectedIndex = ref1[1];
    var indexHandler = function(number) {
        if (number < 0 || number === images.length) {
            return;
        }
        setSelectedIndex(number);
    };
    var onCloseHanlder = function() {
        setState(!state);
        setThumbsSwiper(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pop_up_base["default"], {
        state: state,
        title: title,
        desc: desc !== null && desc !== void 0 ? desc : undefined,
        thumbsChildren: ThumbsElement(images, setThumbsSwiper, selectedIndex, setSelectedIndex),
        type: "galery",
        funcionOnClose: onCloseHanlder,
        className: "bg-white ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                initialSlide: initialIndex,
                className: "ml-2 h-[60vh] w-[70vw] sm:ml-0 md:h-[70vh]",
                spaceBetween: 10,
                navigation: {
                    nextEl: ".SiguientePopUpGaleria",
                    prevEl: ".AnteriorPopUpGaleria"
                },
                thumbs: {
                    // @see https://github.com/nolimits4web/swiper/issues/5630#issuecomment-1111418301
                    swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                },
                modules: [
                    modules/* FreeMode */.Rv,
                    modules/* Navigation */.W_,
                    modules/* Thumbs */.o3
                ],
                onSlideChangeTransitionEnd: function(e) {
                    return indexHandler(e.activeIndex);
                },
                children: [
                    images.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: "rounded-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item,
                                className: "h-full w-full rounded-md lg:w-1/2",
                                layout: "fill",
                                alt: "Imagen de la vivienda ".concat(index + 1),
                                objectFit: "cover"
                            })
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative -top-1/2 z-20 flex w-full -translate-y-1/2 flex-row items-center justify-between px-1 text-primary-400",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Izquierda["default"], {
                                width: 30,
                                onClick: function() {
                                    return indexHandler(selectedIndex - 1);
                                },
                                className: "AnteriorPopUpGaleria cursor-pointer",
                                role: "button"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Derecha["default"], {
                                width: 30,
                                onClick: function() {
                                    return indexHandler(selectedIndex + 1);
                                },
                                className: "SiguientePopUpGaleria cursor-pointer",
                                role: "button"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
PopUpGaleria.displayName = "PopUpGaleria";

;// CONCATENATED MODULE: ./components/atoms/multimedia/Galeria/PopUpGaleria/index.ts

/* harmony default export */ var Galeria_PopUpGaleria = (PopUpGaleria);


/***/ }),

/***/ 53117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pop_up_base; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 23 modules
var dialog = __webpack_require__(65518);
// EXTERNAL MODULE: ./public/assets/icons/ExitPopUp.svg
var ExitPopUp = __webpack_require__(61740);
;// CONCATENATED MODULE: ./components/atoms/pop-up-base/PopUpBase.tsx



/**
 * PopUpBase
 */ var PopUpBase = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, state = param.state, children = param.children, funcionOnClose = param.funcionOnClose, thumbsChildren = param.thumbsChildren, desc = param.desc, title = param.title, _type = param.type, type = _type === void 0 ? "base" : _type, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
        open: state,
        onClose: funcionOnClose,
        className: "fixed inset-0 z-50 grid place-items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                className: "fixed inset-0 bg-[rgba(21,33,39,0.7)]",
                onClick: funcionOnClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                className: "z-50 flex flex-col items-center overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-full flex-col items-center justify-around gap-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                backgroundColor: "".concat(bgColor, " !important")
                            },
                            className: "flex flex-col rounded-md text-primary-400 sm:justify-around ".concat(type === "galery" ? "bg-transparent sm:bg-white" : "", " h-fit w-full max-w-[calc(100vw-2rem)] p-4 sm:h-auto sm:w-auto sm:p-5 ").concat(className),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-2 flex flex-row justify-between gap-4 sm:mb-2 sm:mt-0 ".concat(type === "galery" ? "my-5" : "my-2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col gap-1",
                                            children: [
                                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-heading text-heading--h3",
                                                    children: title
                                                }),
                                                desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-body text-body--secondary--bold",
                                                    children: desc
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopUp["default"], {
                                            heigth: 32,
                                            width: 32,
                                            className: "flex-shrink-0 hover:cursor-pointer",
                                            onClick: funcionOnClose
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: type === "galery" ? "min-h-[60vh] min-w-[80vw]" : type === "iframe" ? desc ? "relative min-h-[calc(100vh-68px)] min-w-[100vw] sm:min-h-[60vh] sm:min-w-[80vw]" : "relative min-h-[calc(100vh-48px)] min-w-[100vw] sm:min-h-[60vh] sm:min-w-[80vw]" : "h-[60vh] overflow-y-auto sm:h-auto sm:w-auto",
                                    children: children
                                })
                            ]
                        }),
                        thumbsChildren && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-3 min-h-fit sm:mb-0",
                            children: thumbsChildren
                        })
                    ]
                })
            })
        ]
    });
};
PopUpBase.displayName = "PopUpBase";

;// CONCATENATED MODULE: ./components/atoms/pop-up-base/index.ts

/* harmony default export */ var pop_up_base = (PopUpBase);


/***/ }),

/***/ 60652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RQ": function() { return /* binding */ VARIANT_MAPS; },
/* harmony export */   "r4": function() { return /* binding */ SectionText; }
/* harmony export */ });
/* unused harmony export VARIANT_MAPS_TITLE */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77215);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23097);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89136);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62123);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38959);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94557);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97932);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60864);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81246);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64903);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        flex gap-8 md:mb-6 md:gap-16\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-w-[802px] justify-between\n            ",
        "\n            ",
        "   \n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              text-heading text-heading-mobile--h2 !font-normal md:text-heading--h2 \n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            flex max-w-[802px]  flex-col gap-4\n            ",
        "\n            ",
        "\n            ",
        " \n           \n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                  mb-5  break-keep !text-[20px]  !font-light  leading-[28px] md:mb-6\n                  ",
        "\n                  ",
        "\n                  ",
        "\n                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var TEXT_ALIGN_MAPS = {
    center: "flex md:justify-center md:text-center",
    end: "flex md:justify-end md:text-end",
    start: "flex md:justify-start md:text-start"
};
var TEXT_ALIGN_MAPS_MOBILE = {
    center: "flex justify-center text-center",
    end: "flex justify-end text-end",
    start: "flex justify-start text-start"
};
var VARIANT_MAPS = {
    primary: "text-primary-400",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var VARIANT_MAPS_TITLE = {
    primary: "!text-brownie-500",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var SectionText = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, desc = param.desc, direction = param.direction, textAlign = param.textAlign, textAlignMobile = param.textAlignMobile, title = param.title, caracteristics = param.caracteristics, variant = param.variant, _caracCols = param.caracCols, caracCols = _caracCols === void 0 ? 2 : _caracCols, directionMobile = param.directionMobile, _showSeeMore = param.showSeeMore, showSeeMore = _showSeeMore === void 0 ? false : _showSeeMore, subtitle = param.subtitle;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var rowCarac = direction === "row" && directionMobile === "row" && !caracteristics;
    var captionAlignment = direction === "column" ? textAlign === "center" ? "md:justify-center md:items-center" : textAlign === "end" ? "md:justify-end md:items-end" : "md:justify-start md:items-start" : "";
    var MobileAlignment = direction === "column" ? textAlignMobile === "center" ? "justify-center items-center" : textAlignMobile === "end" ? "justify-end items-end" : "justify-start items-start" : "";
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ var labels = t("components.atoms.seeMore.labels", "common", {
        returnObjects: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject(), rowCarac ? "flex-row" : "\n              ".concat(directionMobile === "row" ? "flex-row " : "flex-col", "  \n              ").concat(direction === "row" ? "justify-between md:flex-row " : "md:flex-col", "\n            "), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: rowCarac ? "w-full max-w-fit md:w-full" : direction === "row" ? "w-full max-w-fit md:w-1/2" : "",
                children: [
                    caption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        align: textAlign,
                        className: "mb-4 ".concat(captionAlignment, " ").concat(MobileAlignment),
                        mobileAlignment: textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign,
                        variant: variant,
                        children: caption
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject1(), TEXT_ALIGN_MAPS[textAlign], TEXT_ALIGN_MAPS_MOBILE[textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject2(), VARIANT_MAPS_TITLE[variant], !caracteristics ? "w-full" : "sm:w-1/2"),
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                            className: "text-heading text-heading--h5 ".concat(VARIANT_MAPS[variant]),
                            children: subtitle
                        })
                    })
                ]
            }),
            desc || caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject3(), showSeeMore ? "sm:flex-col" : "sm:flex-row", rowCarac ? "w-full md:w-1/2" : "", direction === "row" && !caracteristics ? "w-full md:w-1/2" : ""),
                children: [
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        condition: showSeeMore,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                heigthPx: 150,
                                expanded: false,
                                labels: {
                                    viewLess: labels.viewLess,
                                    viewMore: labels.viewMore
                                },
                                children: children
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            html: desc,
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject4(), !caracteristics ? "w-full" : "w-full md:w-1/2", VARIANT_MAPS[variant], TEXT_ALIGN_MAPS[textAlign])
                        })
                    }),
                    caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: 'sm:before:content-[" "] flex w-full flex-row sm:w-1/2 sm:before:mr-5 sm:before:block sm:before:h-auto sm:before:w-px sm:before:border-l sm:before:border-primary-400 ',
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "w-full !gap-3 text-primary-400 ",
                            xs: caracCols,
                            md: caracCols,
                            lg: caracCols,
                            children: caracteristics.map(function(child, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item, {
                                    className: "flex flex-row gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            src: child.icon,
                                            width: 20,
                                            height: 20
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "text-body text-body--secondary",
                                            children: child.text
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
SectionText.displayName = "SectionText";


/***/ }),

/***/ 67526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _SectionText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60652);

/* harmony default export */ __webpack_exports__["Z"] = (_SectionText__WEBPACK_IMPORTED_MODULE_0__/* .SectionText */ .r4);


/***/ }),

/***/ 97932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ see_more; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var atoms_icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(52994);
;// CONCATENATED MODULE: ./components/atoms/see-more/SeeMore.tsx






/**
 * SeeMore
 */ var SeeMore = function(param) {
    var children = param.children, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, labels = param.labels, heigthPx = param.heigthPx, numberOfElements = param.numberOfElements, icon = param.icon, className = param.className, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel;
    var ref = (0,react.useState)(expanded), isExpanded = ref[0], setExpanded = ref[1];
    var t = (0,useTranslation/* default */.Z)("common").t;
    var toggle = function(state) {
        setExpanded(state);
    };
    var firstChild = (0,utils/* toArray */.qo)(children)[0];
    var firstChildRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(expanded), seeMore = ref1[0], setSeeMore = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, [
        firstChildRef,
        heigthPx
    ]);
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, [
        heigthPx
    ]);
    if (!labels) {
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ labels = t("components.atoms.seeMore.labels", "common", {
            returnObjects: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            numberOfElements ? (0,utils/* toArray */.qo)(children).map(function(child, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(index < numberOfElements ? "h-full min-h-full min-w-full opacity-100" : isExpanded ? "h-full min-h-full min-w-full opacity-100" : "h-0 opacity-0 ", " col-span-2 transition-all duration-500 md:col-span-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, (0,_object_spread/* default */.Z)({}, child.props, typeof child.type === "function" ? {
                        seen: index < numberOfElements ? true : isExpanded ? true : false
                    } : {}))
                }, index);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-full transform overflow-hidden transition-all duration-500 ".concat(isExpanded ? "max-h-[1000px]" : "".concat(seeMore ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[35px] after:bg-gradient-to-t after:from-white after:to-[rgba(248,247,246,0.3)] after:content-['']" : "")),
                style: {
                    maxHeight: !isExpanded ? "".concat(heigthPx, "px") : "1000px"
                },
                children: firstChild && /*#__PURE__*/ react.cloneElement(firstChild, {
                    ref: firstChildRef
                })
            }),
            (children === null || children === void 0 ? void 0 : children.length) > numberOfElements || seeMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-10 col-start-1 col-end-[-1] mt-2 flex ".concat(!hideLabel && "w-full", " cursor-pointer flex-row items-center justify-center gap-2 ").concat(className),
                onClick: function() {
                    return toggle(!isExpanded);
                },
                children: [
                    !hideLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                        as: "span",
                        variant: variant,
                        arrow: false,
                        children: isExpanded ? labels === null || labels === void 0 ? void 0 : labels.viewLess : labels === null || labels === void 0 ? void 0 : labels.viewMore
                    }),
                    icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "transform transition-all duration-500 ".concat(isExpanded ? "rotate-180" : "rotate-0", "\n            "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_icon/* default */.Z, {
                            height: 10,
                            width: 10,
                            src: icon
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
SeeMore.displayName = "SeeMore";

;// CONCATENATED MODULE: ./components/atoms/see-more/index.ts

/* harmony default export */ var see_more = (SeeMore);


/***/ }),

/***/ 74637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ atoms_select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(36045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(74772);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
;// CONCATENATED MODULE: ./components/atoms/select/Select.tsx








/**
 * Select
 */ var Select = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _elements = param.elements, elements = _elements === void 0 ? [] : _elements, name = param.name, defaultValue = param.defaultValue, label = param.label, requiredMessage = param.requiredMessage;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors, setValue = ref.setValue, trigger = ref.trigger;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var elemntIndex = elements.findIndex(function(elemt) {
        return (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) === elemt.value.toString();
    });
    var selectValidation = function(value) {
        return value !== "-1" || "Please select a valid option";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase ".concat(errors[name] && "text-[#ff0000]"),
                children: [
                    label,
                    requiredMessage && " *"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: name
            }, register(name, (0,_object_spread/* default */.Z)({}, requiredMessage !== undefined ? {
                required: requiredMessage,
                validate: selectValidation
            } : {
                required: requiredMessage
            }))), {
                name: name,
                defaultValue: elemntIndex !== -1 ? defaultValue ? defaultValue.value : 0 : elemntIndex,
                className: "text-body ".concat(errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "text-body--primary border-primary-400 text-primary-400 placeholder-primary-400", "   w-full cursor-pointer border-b  bg-transparent pb-2  outline-none ").concat(className),
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setValue(name, e.target.value);
                                    return [
                                        4,
                                        trigger(name)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    defaultValue && elemntIndex === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: defaultValue.value,
                        children: defaultValue.label
                    }) : null,
                    elements === null || elements === void 0 ? void 0 : elements.map(function(child, index) {
                        return /*#__PURE__*/ (0,react.createElement)("option", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child.disabled && {
                            disabled: true
                        }), {
                            className: "w-full",
                            key: index,
                            value: child.value,
                            children: [
                                child.label,
                                child.disabled ? t("components.atoms.select.soon") : ""
                            ]
                        }));
                    })
                ]
            })),
            errors[name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-other--detail text-[#ff0000]",
                children: errors[name].message
            })
        ]
    });
};
Select.displayName = "Select";

;// CONCATENATED MODULE: ./components/atoms/select/index.ts

/* harmony default export */ var atoms_select = (Select);


/***/ }),

/***/ 55793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(96052);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(43203);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(9434);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/multimedia/Galeria/PopUpGaleria/index.ts + 1 modules
var PopUpGaleria = __webpack_require__(46402);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(36045);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(74772);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(42667);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./public/assets/icons/CheckmarkCircle.svg
var CheckmarkCircle = __webpack_require__(15457);
// EXTERNAL MODULE: ./public/assets/icons/WarningCircle.svg
var WarningCircle = __webpack_require__(53516);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3561);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(51315);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}

;// CONCATENATED MODULE: ./lib/utils/localesByCountryCode.ts

var localesByCountryCode = {
    es: [
        "ES",
        "MX",
        "AR",
        "CL",
        "CO",
        "PE",
        "VE",
        "BO",
        "PY",
        "UY",
        "DO",
        "CR",
        "GT",
        "HN",
        "NI",
        "SV",
        "PA",
        "CU", 
    ],
    en: [
        "US",
        "GB",
        "CA",
        "AU",
        "NZ",
        "IE",
        "ZA",
        "IN",
        "PH",
        "SG",
        "MY",
        "NG",
        "JM",
        "TT", 
    ],
    fr: [
        "FR",
        "CA",
        "BE",
        "CH",
        "LU",
        "MC"
    ],
    de: [
        "DE",
        "AT",
        "CH",
        "LU"
    ],
    zh: [
        "CN",
        "TW",
        "HK",
        "SG"
    ],
    pt: [
        "PT",
        "BR",
        "MZ",
        "AO",
        "GW",
        "CV",
        "TL",
        "ST"
    ],
    it: [
        "IT",
        "CH",
        "SM",
        "VA"
    ],
    nl: [
        "NL",
        "BE",
        "SR",
        "AW",
        "CW"
    ],
    ar: [
        "SA",
        "AE",
        "EG",
        "IQ",
        "JO",
        "LB",
        "OM",
        "QA",
        "SY",
        "YE",
        "KW",
        "BH"
    ],
    ru: [
        "RU",
        "BY",
        "KZ",
        "KG"
    ],
    ja: [
        "JP"
    ],
    ko: [
        "KR"
    ],
    sv: [
        "SE",
        "FI"
    ],
    no: [
        "NO"
    ],
    fi: [
        "FI"
    ],
    da: [
        "DK"
    ],
    el: [
        "GR",
        "CY"
    ],
    tr: [
        "TR"
    ],
    he: [
        "IL"
    ],
    cs: [
        "CZ"
    ],
    sk: [
        "SK"
    ],
    pl: [
        "PL"
    ],
    hu: [
        "HU"
    ],
    ro: [
        "RO"
    ],
    bg: [
        "BG"
    ],
    uk: [
        "UA"
    ],
    hr: [
        "HR"
    ],
    sr: [
        "RS",
        "ME",
        "BA"
    ],
    lt: [
        "LT"
    ],
    lv: [
        "LV"
    ],
    et: [
        "EE"
    ],
    sl: [
        "SI"
    ],
    mk: [
        "MK"
    ],
    th: [
        "TH"
    ],
    vi: [
        "VN"
    ],
    ms: [
        "MY",
        "BN"
    ],
    id: [
        "ID"
    ]
};
var getLocaleFromCountryCode = function(countryCode) {
    var upperCountryCode = countryCode.toUpperCase();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(localesByCountryCode)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _slicedToArray(_step.value, 2), languageCode = _value[0], countries = _value[1];
            if (countries.includes(upperCountryCode)) {
                return "".concat(languageCode, "-").concat(upperCountryCode);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};

// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(47675);
// EXTERNAL MODULE: ./components/atoms/select/index.ts + 1 modules
var atoms_select = __webpack_require__(74637);
;// CONCATENATED MODULE: ./components/atoms/input/Input.tsx






/**
 * Input
 */ var Input = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, placeholder = param.placeholder, type = param.type, name = param.name, requiredMessage = param.requiredMessage, label = param.label, onBlur = param.onBlur;
    var ref;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), register = ref1.register, errors = ref1.formState.errors, trigger = ref1.trigger, setValue = ref1.setValue, setError = ref1.setError, clearErrors = ref1.clearErrors;
    var emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase ".concat(errors[name] && "text-[#ff0000]"),
                children: [
                    label,
                    requiredMessage && " *"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                id: name,
                placeholder: placeholder,
                type: type
            }, register(name, {
                required: requiredMessage
            })), {
                className: "text-body  text-body--primary border-b bg-transparent pb-2 font-light outline-none ".concat(errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "border-primary-400 text-primary-400 placeholder-primary-400", "  ").concat(className),
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setValue(name, e.target.value);
                                    return [
                                        4,
                                        trigger(name)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                onBlur: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            if (type === "email") {
                                if (!emailPattern.test(e.target.value)) {
                                    setError(name, {
                                        type: "pattern",
                                        message: "Introduce un email v\xe1lido"
                                    });
                                } else {
                                    clearErrors(name);
                                }
                            }
                            if (onBlur) onBlur(e);
                            return [
                                2
                            ];
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-other--detail text-[#ff0000] ".concat(errors[name] ? "block" : "hidden"),
                children: (ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message
            })
        ]
    });
};
Input.displayName = "Input";

;// CONCATENATED MODULE: ./components/atoms/input/index.ts

/* harmony default export */ var input = (Input);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
;// CONCATENATED MODULE: ./components/atoms/text-area/TextArea.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          max-h-96 w-full resize-y border-b bg-transparent font-light outline-none\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          text-other--detail text-[#ff0000]\n          ",
        "\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/**
 * TextArea
 */ var TextArea = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _rows = param.rows, rows = _rows === void 0 ? 3 : _rows, label = param.label, name = param.name, requiredMessage = param.requiredMessage, placeholder = param.placeholder;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors, setValue = ref.setValue, trigger = ref.trigger;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: name,
                className: "text-other--label-form uppercase",
                children: [
                    label,
                    requiredMessage && " *"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register(name, {
                required: requiredMessage
            })), {
                name: name !== null && name !== void 0 ? name : "description",
                rows: rows
            }), placeholder && {
                placeholder: placeholder
            }), {
                id: name,
                className: (0,es/* oneLine */.f9)(_templateObject(), errors[name] ? "border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]" : "border-primary-400 text-primary-400 placeholder-primary-400", className),
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setValue(name, e.target.value);
                                    return [
                                        4,
                                        trigger(name)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,es/* oneLine */.f9)(_templateObject1(), errors[name] ? "block" : "hidden"),
                children: requiredMessage
            })
        ]
    });
};
TextArea.displayName = "TextArea";

;// CONCATENATED MODULE: ./components/atoms/text-area/index.ts

/* harmony default export */ var text_area = (TextArea);

;// CONCATENATED MODULE: ./components/atoms/checkbox/Checkbox.tsx





function Checkbox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n             cursor-pointer\n            ",
        "\n          "
    ]);
    Checkbox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Checkbox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          text-other--detail text-[#ff0000]\n          ",
        "\n        "
    ]);
    Checkbox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



/**
 * Checkbox
 */ var Checkbox = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, text = param.text, name = param.name, requiredMessage = param.requiredMessage;
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, errors = ref.formState.errors, setValue = ref.setValue, trigger = ref.trigger;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-5 min-w-[15px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            className: (0,es/* oneLine */.f9)(Checkbox_templateObject(), errors[name] ? "border-[#ff0000]" : "accent-primary-400")
                        }, register(name, {
                            required: requiredMessage
                        })), {
                            type: "checkbox",
                            id: name,
                            onChange: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                setValue(name, e.target.checked);
                                                return [
                                                    4,
                                                    trigger(name)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "text-other text-other--detail cursor-pointer ".concat(errors[name] ? "text-[#ff0000] " : "text-primary-400"),
                        htmlFor: name,
                        children: [
                            requiredMessage && " *",
                            text
                        ]
                    })
                ]
            }),
            errors[name] && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,es/* oneLine */.f9)(Checkbox_templateObject1(), errors[name] ? "block" : "hidden"),
                children: requiredMessage
            })
        ]
    });
};
Checkbox.displayName = "Checkbox";

;// CONCATENATED MODULE: ./components/atoms/checkbox/index.ts

/* harmony default export */ var atoms_checkbox = (Checkbox);

// EXTERNAL MODULE: ./components/atoms/see-more/index.ts + 1 modules
var see_more = __webpack_require__(97932);
// EXTERNAL MODULE: ./components/atoms/prose/index.ts + 1 modules
var prose = __webpack_require__(60864);
;// CONCATENATED MODULE: ./components/organisms/contact-form-landing/ContactFormLanding.tsx










var PhoneInput = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8238), __webpack_require__.e(4752)]).then(__webpack_require__.bind(__webpack_require__, 34752));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34752)
            ];
        }
    },
    ssr: false
});
/**
 * ContactFormLanding
 */ var ContactFormLanding = function(param) {
    var textPolicies = param.textPolicies, buildingsSelectValues = param.buildingsSelectValues, mapOfAccommodation = param.mapOfAccommodation, watchBuilding = param.watchBuilding, hearUsSelect = param.hearUsSelect, defaultBuilding = param.defaultBuilding, defaultApartment = param.defaultApartment, hearUsDefaultValue = param.hearUsDefaultValue, methods = param.methods, validatePhone = param.validatePhone, validateEmails = param.validateEmails, resetForm = param.resetForm, phoneCountry = param.phoneCountry, setPhoneCountry = param.setPhoneCountry;
    var ref = (0,useTranslation/* default */.Z)("common"), t = ref.t, lang = ref.lang;
    var ref1 = (0,react.useState)(0), currentStep = ref1[0], setCurrentStep = ref1[1];
    var ref2 = (0,react.useState)(false), readyToSubmit = ref2[0], setReadyToSubmit = ref2[1];
    var ref3 = (0,react.useState)(false), hasRequiredFields = ref3[0], sethasRequiredFields = ref3[1];
    var swiperRef = (0,react.useRef)(null);
    var ref4 = (0,index_esm/* useFormContext */.Gc)(), errors = ref4.formState.errors, getValues = ref4.getValues;
    var handleFormReset = function() {
        setReadyToSubmit(false);
        handleStep(0);
    };
    var handleStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(index) {
            var fieldsToValidate, isEmailValid, isPhoneValid, isValid, email, emailConfirm, phoneNumber, _fieldsToValidate, nextStepFieldsToValidate;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        fieldsToValidate = pages[currentStep].fieldsToValidate;
                        if (!(!resetForm && (index > currentStep || index < currentStep && readyToSubmit))) return [
                            3,
                            4
                        ];
                        isEmailValid = true;
                        isPhoneValid = true;
                        return [
                            4,
                            methods.trigger(fieldsToValidate)
                        ];
                    case 1:
                        isValid = _state.sent();
                        if (!isValid) {
                            if (swiperRef.current) {
                                swiperRef.current.updateAutoHeight();
                            }
                            return [
                                2
                            ];
                        }
                        if (fieldsToValidate && fieldsToValidate.includes("email")) {
                            email = methods.getValues("email");
                            emailConfirm = methods.getValues("emailConfirm");
                            isEmailValid = validateEmails(email, emailConfirm);
                        }
                        if (!(fieldsToValidate && fieldsToValidate.includes("telephone"))) return [
                            3,
                            3
                        ];
                        phoneNumber = methods.getValues("telephone");
                        return [
                            4,
                            validatePhone(phoneNumber, phoneCountry)
                        ];
                    case 2:
                        isPhoneValid = _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!isEmailValid || !isPhoneValid) {
                            if (swiperRef.current) {
                                swiperRef.current.updateAutoHeight();
                            }
                            return [
                                2
                            ];
                        }
                        _state.label = 4;
                    case 4:
                        if (index > -1) {
                            ;
                            nextStepFieldsToValidate = (_fieldsToValidate = pages[index].fieldsToValidate) !== null && _fieldsToValidate !== void 0 ? _fieldsToValidate : [];
                            setCurrentStep(index);
                            sethasRequiredFields(nextStepFieldsToValidate && nextStepFieldsToValidate.length > 0);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStep(index) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current) {
            var ref;
            swiperRef.current.slideTo(currentStep);
            if (swiperRef === null || swiperRef === void 0 ? void 0 : (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.isEnd) setReadyToSubmit(true);
        }
    }, [
        currentStep,
        Object.keys(errors)
    ]);
    (0,react.useEffect)(function() {
        handleFormReset();
    }, [
        resetForm
    ]);
    var ref5;
    var pages = [
        {
            title: t("components.organisms.contactForm.steps.location"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                        label: t("components.organisms.contactForm.buildingLabel"),
                        name: "building",
                        requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                        elements: buildingsSelectValues,
                        defaultValue: {
                            label: defaultBuilding === null || defaultBuilding === void 0 ? void 0 : defaultBuilding.label,
                            value: defaultBuilding === null || defaultBuilding === void 0 ? void 0 : defaultBuilding.id.toString()
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                        label: t("components.organisms.contactForm.accommodationLabel"),
                        name: "accommodation",
                        defaultValue: defaultApartment,
                        elements: ((ref5 = mapOfAccommodation.get(parseInt(watchBuilding === null || watchBuilding === void 0 ? void 0 : watchBuilding.toString()))) !== null && ref5 !== void 0 ? ref5 : []).filter(function(item, index, self) {
                            return index === self.findIndex(function(t) {
                                return t.value === item.value;
                            });
                        })
                    })
                ]
            }),
            fieldsToValidate: [
                "building"
            ]
        },
        {
            title: t("components.organisms.contactForm.steps.personalData"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        label: t("components.organisms.contactForm.nameLabel"),
                        requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                        name: "name",
                        type: "text",
                        placeholder: t("components.organisms.contactForm.namePlaceholder")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        label: t("components.organisms.contactForm.lastNameLabel"),
                        name: "lastName",
                        type: "text",
                        placeholder: t("components.organisms.contactForm.lastNamePlaceholder"),
                        requiredMessage: t("components.organisms.contactForm.requiredMessage")
                    })
                ]
            }),
            fieldsToValidate: [
                "name",
                "lastName"
            ]
        },
        {
            title: t("components.organisms.contactForm.steps.contact"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        label: t("components.organisms.contactForm.emailLabel"),
                        name: "email",
                        type: "email",
                        placeholder: t("components.organisms.contactForm.emailPlaceholder"),
                        requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                        onBlur: function() {
                            validateEmails(getValues("email"), getValues("emailConfirm"));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                        label: t("components.organisms.contactForm.emailConfirmLabel"),
                        name: "emailConfirm",
                        type: "email",
                        placeholder: t("components.organisms.contactForm.emailPlaceholder"),
                        requiredMessage: t("components.organisms.contactForm.emailConfirmationRequiredMessage"),
                        onBlur: function() {
                            validateEmails(getValues("email"), getValues("emailConfirm"));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput, {
                        label: t("components.organisms.contactForm.phoneLabel"),
                        name: "telephone",
                        language: lang === "es" ? "es" : "eng",
                        requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                        className: "h-full",
                        setPhoneCountry: setPhoneCountry
                    })
                ]
            }),
            fieldsToValidate: [
                "email",
                "emailConfirm",
                "telephone"
            ]
        },
        {
            title: t("components.organisms.contactForm.steps.sourceAndNotes"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, (0,_object_spread/* default */.Z)({
                        label: t("components.organisms.contactForm.hearAboustUs"),
                        name: "hearUs",
                        defaultValue: hearUsDefaultValue
                    }, hearUsSelect)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_area, {
                        label: t("components.organisms.contactForm.addMore"),
                        rows: 5,
                        name: "addMore",
                        placeholder: t("components.organisms.contactForm.addMorePlaceholder")
                    })
                ]
            })
        },
        {
            title: t("components.organisms.contactForm.steps.lastStep"),
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_checkbox, {
                        text: t("components.organisms.contactForm.marketingOptIn"),
                        name: "marketingOptIn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_checkbox, {
                        text: t("components.organisms.contactForm.marketingGreystar"),
                        name: "marketingGreystar"
                    })
                ]
            })
        }, 
    ];
    var pageNavigation = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex w-full items-center justify-center gap-1 border-b border-state-primary-disabled p-4",
        children: pages.map(function(page, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "h-1 w-[5%] border-0 ".concat(index < currentStep && "bg-state-primary-default", " ").concat(index > currentStep && "bg-state-primary-disabled"),
                        style: index === currentStep ? {
                            backgroundImage: "linear-gradient(to right, var(--tw-color-state-primary-default) 50%, var(--tw-color-state-primary-disabled) 50%)"
                        } : {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "flex h-6 w-6 cursor-pointer items-center justify-center rounded-full border border-state-primary-default text-xs ".concat(index <= currentStep ? "bg-state-primary-default text-text-alternative" : "bg-transparent text-text-primary"),
                        onClick: function() {
                            return handleStep(index);
                        },
                        children: index + 1
                    })
                ]
            }, index);
        })
    });
    (0,react.useEffect)(function() {
        handleFormReset();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
            className: "w-full",
            slidesPerView: 1,
            allowTouchMove: false,
            autoHeight: true,
            onSwiper: function(swiper) {
                swiperRef.current = swiper;
            },
            children: [
                pages.map(function(page, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center justify-center gap-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full flex-col justify-center text-center",
                                    children: [
                                        readyToSubmit && pageNavigation,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-heading-mobile--h3 p-4",
                                            children: page.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full flex-col items-center justify-center gap-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-col gap-4",
                                        children: [
                                            page.content,
                                            hasRequiredFields && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-1 w-full text-[9px] uppercase tracking-wider",
                                                children: t("components.organisms.contactForm.obligatoryFields")
                                            })
                                        ]
                                    })
                                }),
                                currentStep < pages.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full flex-col-reverse gap-4 pb-1 sm:w-fit sm:flex-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            type: "button",
                                            size: "large",
                                            variant: "outline",
                                            className: "w-full sm:max-w-max",
                                            disabled: currentStep === 0,
                                            onClick: function() {
                                                return handleStep(currentStep - 1);
                                            },
                                            children: t("components.organisms.contactForm.landing.back")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                            type: "button",
                                            size: "large",
                                            variant: "primary",
                                            className: "w-full sm:max-w-max",
                                            onClick: function() {
                                                return handleStep(currentStep + 1);
                                            },
                                            children: t("components.organisms.contactForm.landing.next")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                    type: "submit",
                                    size: "large",
                                    variant: "secondary",
                                    className: "w-full max-w-[244px]",
                                    children: t("components.organisms.contactForm.sendButton")
                                })
                            ]
                        })
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-8 flex items-start justify-between gap-2 overflow-hidden transition-all duration-500",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(see_more/* default */.Z, {
                        expanded: false,
                        heigthPx: 50,
                        hideLabel: true,
                        icon: "ArrowDownPri",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                            html: textPolicies,
                            className: "text-other--detail text-xs leading-4 !text-primary-200"
                        })
                    })
                })
            ]
        })
    });
};
ContactFormLanding.displayName = "ContactFormLanding";

;// CONCATENATED MODULE: ./components/organisms/contact-form-landing/index.ts

/* harmony default export */ var contact_form_landing = (ContactFormLanding);

// EXTERNAL MODULE: ./components/atoms/grid/index.ts + 2 modules
var grid = __webpack_require__(81246);
;// CONCATENATED MODULE: ./components/organisms/contact-form-standard/ContactFormStandard.tsx







var ContactFormStandard_PhoneInput = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8238), __webpack_require__.e(4752)]).then(__webpack_require__.bind(__webpack_require__, 34752));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34752)
            ];
        }
    },
    ssr: false
});
/**
 * ContactFormStandart
 */ var ContactFormStandard = function(param) {
    var textPolicies = param.textPolicies, buildingsSelectValues = param.buildingsSelectValues, mapOfAccommodation = param.mapOfAccommodation, watchBuilding = param.watchBuilding, hearUsSelect = param.hearUsSelect, defaultBuilding = param.defaultBuilding, defaultApartment = param.defaultApartment, hearUsDefaultValue = param.hearUsDefaultValue, setPhoneCountry = param.setPhoneCountry;
    var ref = (0,useTranslation/* default */.Z)("common"), t = ref.t, lang = ref.lang;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), errors = ref1.formState.errors;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 top-0 -mt-8 ml-6 lg:ml-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/assets/img/logo/logo-brown.svg",
                    alt: "logo",
                    width: 68,
                    height: 68,
                    className: "object-contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default */.Z, {
                xs: 1,
                md: 1,
                lg: 2,
                className: "!gap-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                            label: t("components.organisms.contactForm.nameLabel"),
                            requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                            name: "name",
                            type: "text",
                            placeholder: t("components.organisms.contactForm.namePlaceholder")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                            label: t("components.organisms.contactForm.lastNameLabel"),
                            name: "lastName",
                            type: "text",
                            placeholder: t("components.organisms.contactForm.lastNamePlaceholder"),
                            requiredMessage: t("components.organisms.contactForm.requiredMessage")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                            label: t("components.organisms.contactForm.emailLabel"),
                            name: "email",
                            type: "email",
                            placeholder: t("components.organisms.contactForm.emailPlaceholder"),
                            requiredMessage: t("components.organisms.contactForm.requiredMessage")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input, {
                            label: t("components.organisms.contactForm.emailConfirmLabel"),
                            name: "emailConfirm",
                            type: "email",
                            placeholder: t("components.organisms.contactForm.emailPlaceholder"),
                            requiredMessage: t("components.organisms.contactForm.emailConfirmationRequiredMessage")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFormStandard_PhoneInput, {
                            label: t("components.organisms.contactForm.phoneLabel"),
                            name: "telephone",
                            language: lang === "es" ? "es" : "eng",
                            requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                            className: "h-full ".concat(errors.telephone && "text-[#ff0000] placeholder-[#ff0000]"),
                            setPhoneCountry: setPhoneCountry
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, (0,_object_spread/* default */.Z)({
                            label: t("components.organisms.contactForm.hearAboustUs"),
                            name: "hearUs",
                            defaultValue: hearUsDefaultValue
                        }, hearUsSelect))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                            label: t("components.organisms.contactForm.buildingLabel"),
                            name: "building",
                            requiredMessage: t("components.organisms.contactForm.requiredMessage"),
                            // eslint-disable-next-line
                            // @ts-ignore
                            elements: buildingsSelectValues,
                            defaultValue: {
                                label: defaultBuilding === null || defaultBuilding === void 0 ? void 0 : defaultBuilding.label,
                                value: defaultBuilding === null || defaultBuilding === void 0 ? void 0 : defaultBuilding.id.toString()
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_select/* default */.Z, {
                            label: t("components.organisms.contactForm.accommodationLabel"),
                            name: "accommodation",
                            defaultValue: defaultApartment,
                            elements: ((ref2 = mapOfAccommodation.get(parseInt(watchBuilding === null || watchBuilding === void 0 ? void 0 : watchBuilding.toString()))) !== null && ref2 !== void 0 ? ref2 : []).filter(function(item, index, self) {
                                return index === self.findIndex(function(t) {
                                    return t.value === item.value;
                                });
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                        colSpanLG: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_area, {
                            label: t("components.organisms.contactForm.addMore"),
                            rows: 5,
                            name: "addMore",
                            placeholder: t("components.organisms.contactForm.addMorePlaceholder")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col justify-around gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-1 text-[9px] uppercase tracking-wider",
                        children: t("components.organisms.contactForm.obligatoryFields")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_checkbox, {
                        text: t("components.organisms.contactForm.marketingOptIn"),
                        name: "marketingOptIn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_checkbox, {
                        text: t("components.organisms.contactForm.marketingGreystar"),
                        name: "marketingGreystar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                type: "submit",
                size: "large",
                variant: "primary",
                className: "my-4 md:ml-auto md:max-w-max",
                children: t("components.organisms.contactForm.sendButton")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                html: textPolicies,
                className: "text-other--detail text-xs leading-4 !text-primary-200"
            })
        ]
    });
};
ContactFormStandard.displayName = "ContactFormStandard";

;// CONCATENATED MODULE: ./components/organisms/contact-form-standard/index.ts

/* harmony default export */ var contact_form_standard = (ContactFormStandard);

;// CONCATENATED MODULE: ./components/organisms/contact-form-base/ContactFormBase.tsx















var PopUp = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53117)
            ];
        }
    },
    ssr: false
});
/**
 * ContactForm
 */ var ContactFormBase = function(param) {
    var textPolicies = param.textPolicies, buildingSelect = param.buildingSelect, accommodationSelect = param.accommodationSelect, hearUsSelect = param.hearUsSelect, className = param.className, _landing = param.landing, landing = _landing === void 0 ? false : _landing, defaultBuilding = param.defaultBuilding, defaultApartment = param.defaultApartment, hearUsDefaultValue = param.hearUsDefaultValue;
    var ref;
    var t = (0,useTranslation/* default */.Z)("common").t;
    var methods = (0,index_esm/* useForm */.cI)();
    var ref1 = (0,react.useState)(false), showModal = ref1[0], setShowModal = ref1[1];
    var ref2 = (0,react.useState)(false), hasError = ref2[0], setHasError = ref2[1];
    var ref3 = (0,react.useState)(false), resetLandingForm = ref3[0], setResetLandingForm = ref3[1];
    var ref4 = (0,react.useState)(null), phoneCountry = ref4[0], setPhoneCountry = ref4[1];
    var Icon = hasError ? WarningCircle["default"] : CheckmarkCircle["default"];
    var close = function() {
        setShowModal(false);
        setHasError(false);
    };
    var buildingsSelectValues = buildingSelect.map(function(building) {
        return {
            label: building.label,
            value: building.id,
            disabled: building.disabled
        };
    });
    var mapOfAccommodation = new Map(accommodationSelect);
    var watchBuilding = methods.watch("building", buildingsSelectValues === null || buildingsSelectValues === void 0 ? void 0 : (ref = buildingsSelectValues[0]) === null || ref === void 0 ? void 0 : ref.value.toString());
    var validatePhone = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(telephone, phoneCountry) {
            var setPhoneError, isMobilePhone, locale, isValid;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setPhoneError = function() {
                            methods.setError("telephone", {
                                type: "custom",
                                message: t("components.organisms.contactForm.phoneError")
                            });
                        };
                        if (!telephone) {
                            setPhoneError();
                            return [
                                2,
                                false
                            ];
                        }
                        if (!phoneCountry) return [
                            2,
                            false
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5340).then(__webpack_require__.bind(__webpack_require__, 75340))
                        ];
                    case 1:
                        isMobilePhone = _state.sent().default;
                        locale = getLocaleFromCountryCode(phoneCountry.countryCode);
                        isValid = isMobilePhone(telephone, locale) || isMobilePhone("+".concat(telephone), locale);
                        if (!isValid) {
                            setPhoneError();
                        }
                        return [
                            2,
                            isValid
                        ];
                }
            });
        });
        return function validatePhone(telephone, phoneCountry) {
            return _ref.apply(this, arguments);
        };
    }();
    var validateEmails = function(email1, email2) {
        var isValid = email1 === email2;
        if (!isValid) {
            methods.setError("emailConfirm", {
                type: "custom",
                message: t("components.organisms.contactForm.emailError")
            });
        }
        return isValid;
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var selectedBuilding, ref, response, body, _tmp, _tmp1, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            validatePhone(data === null || data === void 0 ? void 0 : data.telephone, phoneCountry)
                        ];
                    case 1:
                        if (!_state.sent()) return [
                            2
                        ];
                        if (!validateEmails(data === null || data === void 0 ? void 0 : data.email, data === null || data === void 0 ? void 0 : data.emailConfirm)) return [
                            2
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            11,
                            ,
                            12
                        ]);
                        selectedBuilding = buildingSelect.find(function(building) {
                            return building.id.toString() === data.building;
                        });
                        return [
                            4,
                            fetch("/api/lavanda", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    name: data.name,
                                    lastName: data.lastName,
                                    email: data.email,
                                    phone: "+".concat(data.telephone),
                                    description: (ref = data === null || data === void 0 ? void 0 : data.addMore) !== null && ref !== void 0 ? ref : "No se ha a\xf1adido descripci\xf3n",
                                    marketingOptIn: data.marketingOptIn,
                                    marketingGreystar: data.marketingGreystar,
                                    hearUs: data.hearUs,
                                    building: {
                                        name: selectedBuilding === null || selectedBuilding === void 0 ? void 0 : selectedBuilding.label,
                                        id: selectedBuilding === null || selectedBuilding === void 0 ? void 0 : selectedBuilding.endpointId
                                    },
                                    typeOfApartment: data.accommodation
                                })
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 4:
                        body = _state.sent();
                        if (!response.ok) return [
                            3,
                            9
                        ];
                        _tmp = {
                            event: "generate_lead",
                            lead_type: "contact",
                            provincia: ""
                        };
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)("+".concat(data.telephone))
                        ];
                    case 5:
                        _tmp.phone_number = _state.sent(), _tmp.edificio = selectedBuilding === null || selectedBuilding === void 0 ? void 0 : selectedBuilding.label, _tmp.tipo_de_apartamento = data.accommodation, _tmp.conocido = data.hearUs;
                        _tmp1 = {};
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)(data.name)
                        ];
                    case 6:
                        _tmp1.first_name = _state.sent();
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)(data.lastName)
                        ];
                    case 7:
                        _tmp.address = (_tmp1.last_name = _state.sent(), _tmp1);
                        return [
                            4,
                            (0,helpers/* sha256 */.JQ)(data.email)
                        ];
                    case 8:
                        helpers/* gtmPush.apply */.De.apply(void 0, [
                            (_tmp.email = _state.sent(), _tmp)
                        ]);
                        setShowModal(true);
                        methods.clearErrors();
                        methods.reset();
                        landing && setResetLandingForm(true);
                        return [
                            3,
                            10
                        ];
                    case 9:
                        throw new Error(JSON.stringify(body));
                    case 10:
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e = _state.sent();
                        setHasError(true);
                        setShowModal(true);
                        return [
                            3,
                            12
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, methods), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    className: "\n          relative flex w-full flex-col gap-4 rounded-md bg-white shadow-md ".concat(landing ? "p-5" : "mt-6 p-6 pt-10 lg:p-16", "\n          ").concat(landing ? "lg:h-fit lg:w-2/5 lg:max-w-[500px]" : "", "\n          ").concat(className, "\n        "),
                    onSubmit: methods.handleSubmit(onSubmit),
                    children: landing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_form_landing, {
                        textPolicies: textPolicies,
                        buildingsSelectValues: buildingsSelectValues,
                        mapOfAccommodation: mapOfAccommodation,
                        watchBuilding: watchBuilding,
                        hearUsSelect: hearUsSelect,
                        defaultBuilding: defaultBuilding,
                        defaultApartment: defaultApartment,
                        hearUsDefaultValue: hearUsDefaultValue,
                        methods: methods,
                        validatePhone: validatePhone,
                        validateEmails: validateEmails,
                        resetForm: resetLandingForm,
                        phoneCountry: phoneCountry,
                        setPhoneCountry: setPhoneCountry
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_form_standard, {
                        textPolicies: textPolicies,
                        buildingsSelectValues: buildingsSelectValues,
                        mapOfAccommodation: mapOfAccommodation,
                        watchBuilding: watchBuilding,
                        hearUsSelect: hearUsSelect,
                        defaultBuilding: defaultBuilding,
                        defaultApartment: defaultApartment,
                        hearUsDefaultValue: hearUsDefaultValue,
                        setPhoneCountry: setPhoneCountry
                    })
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUp, {
                state: showModal,
                funcionOnClose: close,
                className: "bg-surface-01 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex max-w-md flex-col items-center justify-center gap-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            width: "57",
                            className: hasError ? "text-status-error" : "text-status-success"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-heading-mobile--h3 mb-4 lg:text-heading-mobile--h2",
                                    children: hasError ? t("components.organisms.contactForm.popUp.error.title") : t("components.organisms.contactForm.popUp.sucess.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-body--primary",
                                    children: hasError ? t("components.organisms.contactForm.popUp.error.desc") : t("components.organisms.contactForm.popUp.sucess.desc")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            size: "small",
                            variant: "secondary",
                            onClick: close,
                            className: "max-w-max",
                            children: hasError ? t("components.organisms.contactForm.popUp.error.button") : t("components.organisms.contactForm.popUp.sucess.button")
                        })
                    ]
                })
            })
        ]
    });
};
ContactFormBase.displayName = "ContactForm";

;// CONCATENATED MODULE: ./components/organisms/contact-form-base/index.ts

/* harmony default export */ var contact_form_base = (ContactFormBase);

// EXTERNAL MODULE: ./public/assets/icons/DerechaSinBorde.svg
var DerechaSinBorde = __webpack_require__(41521);
// EXTERNAL MODULE: ./public/assets/icons/IzquierdaSinBorde.svg
var IzquierdaSinBorde = __webpack_require__(62794);
;// CONCATENATED MODULE: ./components/templates/contact-form/ContactForm.tsx













/**
 * ContactForm
 */ var ContactForm = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, formValues = param.formValues, title = param.title, landing = param.landing, background = param.background, desc = param.desc, index = param.index, textColor = param.textColor, id = param.id, features = param.features, button = param.button, link = param.link, opensBookingPopup = param.opensBookingPopup, carousel = param.carousel;
    var ref = (0,react.useState)(false), showLavandaPopUp = ref[0], setShowLavandaPopUp = ref[1];
    var ref1 = (0,react.useState)(0), selectedImg = ref1[0], setselectedImg = ref1[1];
    var ref2 = (0,react.useState)(false), openGallery = ref2[0], setOpenGallery = ref2[1];
    var getFeatureColumns = function() {
        if (!features || features.length < 4) return [
            features !== null && features !== void 0 ? features : []
        ];
        var columns = [
            [],
            []
        ];
        features === null || features === void 0 ? void 0 : features.forEach(function(feat, index) {
            var ref;
            columns === null || columns === void 0 ? void 0 : (ref = columns[index <= Math.ceil(features.length / 2 - 1) ? 0 : 1]) === null || ref === void 0 ? void 0 : ref.push(feat);
        });
        return columns;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                scoped: true,
                children: "\n    .backimage {\n      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(255, 247, 243, 0.4)), url(".concat(background.backgroundImageMobile, ");\n      background-size: auto;\n      background-position: top center;\n      \n        @media (min-width: 750px) {\n          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(255, 247, 243, 0.1)), url(").concat(background.backgroundImage, ") !important;\n          background-size: cover !important;\n          background-position: top left;\n        }\n        \n        @media (min-width: 1024px) {\n          background-position: unset;\n        }\n    }\n  ")
            }),
            carousel && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpGaleria["default"], {
                images: carousel,
                setState: setOpenGallery,
                state: openGallery,
                initialIndex: selectedImg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "backimage relative ".concat(landing ? "" : "bg-".concat(background.backgroundColorTop)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 left-0 right-0 top-0 ".concat(landing ? "bg-[rgba(0,0,0,0.4)]" : "bg-".concat(background.backgroundColorTop), " }")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                        id: id,
                        index: index,
                        backgroundColorBottom: background.backgroundColorBottom,
                        backgroundColorTop: background.backgroundColorTop,
                        backgroundColorBottomMobile: background.backgroundColorBottomMobile,
                        backgroundColorTopMobile: background.backgroundColorTopMobile,
                        cutLevel: background.cutLevel,
                        cutLevelMobile: background.cutLevelMobile,
                        hasCutLevel: background.hasCutLevel,
                        className: "!py-14 lg:!py-20 ".concat(landing ? "flex w-full !max-w-none flex-col gap-8 !py-4 px-0 sm:px-5 md:!py-20 md:pr-4 lg:gap-16" : "flex flex-col gap-5", " ").concat(className),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative mx-auto flex max-w-[1450px] flex-col gap-8 lg:gap-14",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-col items-start justify-between ".concat(landing ? "lg:flex-row" : "", " "),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col justify-between gap-6 px-4 sm:gap-10 ".concat(landing ? "lg:w-3/5" : "w-full", " "),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                                                                direction: "column",
                                                                textAlign: landing ? "start" : "center",
                                                                textAlignMobile: "start",
                                                                variant: textColor,
                                                                caption: caption,
                                                                title: title,
                                                                className: landing ? "![&>div>div]:mb-0 !mb-0 w-full justify-start !gap-2 lg:[&>div>div>h2]:text-heading--h1" : "items-center",
                                                                desc: desc
                                                            }),
                                                            features && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "grid w-fit text-white md:grid-cols-2 md:gap-x-4",
                                                                children: getFeatureColumns().map(function(col, colIndex) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex flex-col md:gap-y-2",
                                                                        children: col.map(function(feat, index) {
                                                                            if (feat && feat !== "") {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                    className: "flex w-fit items-center gap-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                                                                                            className: "w-6 min-w-[24px] text-white",
                                                                                            src: "CheckmarkCircle"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "font-secondary",
                                                                                            children: feat
                                                                                        })
                                                                                    ]
                                                                                }, "feat-".concat(index));
                                                                            }
                                                                        })
                                                                    }, colIndex);
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col items-center justify-center gap-6 md:flex-row md:justify-normal md:gap-7 ",
                                                        children: [
                                                            !opensBookingPopup ? (button === null || button === void 0 ? void 0 : button.src) && button.label && button.variant && !opensBookingPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: button.src,
                                                                passHref: true,
                                                                prefetch: false,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                                    className: "font-bold",
                                                                    size: "large",
                                                                    as: "a",
                                                                    variant: button.variant,
                                                                    children: button.label
                                                                })
                                                            }) : (button === null || button === void 0 ? void 0 : button.label) && (button === null || button === void 0 ? void 0 : button.src) && (button === null || button === void 0 ? void 0 : button.variant) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                                                className: "font-bold",
                                                                size: "large",
                                                                variant: button.variant,
                                                                onClick: function() {
                                                                    return setShowLavandaPopUp(!showLavandaPopUp);
                                                                },
                                                                children: button.label
                                                            }),
                                                            (link === null || link === void 0 ? void 0 : link.src) && link.label && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: link === null || link === void 0 ? void 0 : link.src,
                                                                passHref: true,
                                                                prefetch: false,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                                                    arrow: true,
                                                                    variant: link.variant,
                                                                    children: link === null || link === void 0 ? void 0 : link.label
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_form_base, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), {
                                                landing: landing,
                                                className: "hidden lg:block"
                                            }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-col items-center gap-4 px-4 lg:gap-8 lg:px-16",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                className: "w-full",
                                                slidesPerView: "auto",
                                                breakpoints: {
                                                    0: {
                                                        slidesPerView: 1
                                                    },
                                                    360: {
                                                        slidesPerView: "auto"
                                                    }
                                                },
                                                spaceBetween: 30,
                                                modules: [
                                                    modules/* Navigation */.W_,
                                                    modules/* Scrollbar */.LW
                                                ],
                                                navigation: {
                                                    enabled: true,
                                                    nextEl: ".nextImg",
                                                    prevEl: ".prevImg"
                                                },
                                                scrollbar: {
                                                    hide: false,
                                                    draggable: true,
                                                    enabled: true,
                                                    el: ".heroScrollbar"
                                                },
                                                children: carousel === null || carousel === void 0 ? void 0 : carousel.map(function(img, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                        className: "w-full cursor-pointer sm:max-w-fit",
                                                        onClick: function() {
                                                            setselectedImg(index);
                                                            setOpenGallery(true);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: img,
                                                            width: 250,
                                                            height: 164,
                                                            alt: "Hero gallery element"
                                                        })
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "heroScrollbar h-1 w-4/5 bg-[#ffffff61] [&>.swiper-scrollbar-drag]:bg-white ".concat(openGallery ? "hidden" : "")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IzquierdaSinBorde["default"], {
                                        className: "prevImg absolute bottom-[110px] hidden w-8 cursor-pointer text-primary-500 lg:block",
                                        role: "button"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DerechaSinBorde["default"], {
                                        className: "nextImg absolute bottom-[110px] right-0 hidden w-8 cursor-pointer text-primary-500 lg:block",
                                        role: "button"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_form_base, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formValues), {
                                landing: landing,
                                className: "block lg:hidden"
                            }))
                        ]
                    })
                ]
            })
        ]
    });
};
ContactForm.displayName = "ContactForm";

;// CONCATENATED MODULE: ./components/templates/contact-form/index.ts

/* harmony default export */ var contact_form = (ContactForm);


/***/ }),

/***/ 47675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": function() { return /* binding */ gtmPush; },
/* harmony export */   "JQ": function() { return /* binding */ sha256; }
/* harmony export */ });
/* unused harmony export debugGtm */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36045);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74772);


var debugGtm = function(debugMsg, data) {
    var isProd = "production" === "production";
    // eslint-disable-next-line no-console
    if (!isProd) console.log("".concat(debugMsg, ": "), data);
};
var gtmPush = function(data) {
    var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ref;
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push(data);
    debugGtm("GTM PUSH", data);
};
function sha256(message) {
    return _sha256.apply(this, arguments);
}
function _sha256() {
    _sha256 = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(message) {
        var msgUint8, hashBuffer, hashArray, hashHex;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", msgUint8)
                    ];
                case 1:
                    hashBuffer = _state.sent();
                    hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
                    hashHex = hashArray.map(function(b) {
                        return b.toString(16).padStart(2, "0");
                    }).join(""); // convert bytes to hex string
                    return [
                        2,
                        hashHex
                    ];
            }
        });
    });
    return _sha256.apply(this, arguments);
}


/***/ }),

/***/ 36045:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);